<template>
  <div
    class="lang-switcher control has-addons lang-buttons"
  >
    <button
      class="button is-large"
      :class="{ 'is-primary': LangIsActive(lang) }"
      :disabled="LangIsActive(lang)"
      @click="ChangeCurrentLang(lang)"
      v-for="lang in Languages"
      :key="lang"
    >
      {{lang}}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LangSwitcher',
  props: {
    OnLangSwitch: {
      type: Function,
      required: false
    }
  },
  computed: {
    ...mapGetters(['Languages'])
  },
  methods: {
    LangIsActive (lang) {
      if (lang === this.$route.params.lang) {
        return true
      }
      return false
    },
    ChangeCurrentLang (lang) {
      let newLangSeg = `/${lang}/`
      let currentLangSeg = `/${this.$route.params.lang}/`
      if (this.$route.fullPath.length === 3) {
        newLangSeg = newLangSeg.substring(0, newLangSeg.length - 1)
        currentLangSeg = currentLangSeg.substring(0, currentLangSeg.length - 1)
      }
      let newPath = this.$route.fullPath.replace(currentLangSeg, newLangSeg)
      this.$router.push(newPath)
      if (this.OnLangSwitch) {
        this.OnLangSwitch()
      }
    }
  }
}
</script>

<style lang="scss">
.lang-switcher.control.has-addons {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/LangSwitcher.vue